<template>
  <v-tooltip
    v-if="!hideTaxReductionInfo"
    transition="slide-y-reverse-transition"
    nudge-left="40"
    top
    max-width="600"
    open-delay="800"
    color="rgba(255, 0, 0, 0.0)"
  >
    <template #activator="{ props }">
      <v-list-item-subtitle v-bind="props">
        <v-alert
          type="info"
          dense
          color="blue-grey lighten-2"
          icon="mdi-information-outline"
          class="body-2 info-cursor grey--text text--darken-3"
          border="start"
          colored-border
        >
          {{ t('taxReductionInfo.title') }}
        </v-alert>
      </v-list-item-subtitle>
    </template>
    <span>
      <v-card>
        <v-card-text>
          <h4>{{ t('taxReductionInfo.info') }}</h4>
          <ul class="pt-3">
            <li v-for="prerequisite in prerequisites" :key="prerequisite" class="body-2">
              {{ prerequisite }}
            </li>
          </ul>
          <p class="subtitle-2">{{ t('taxReductionInfo.moreInfo') }}</p>
        </v-card-text>
      </v-card>
    </span>
  </v-tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useLabel } from '@/composables/useLabel';
import store from '@/store';
import i18n from '@/plugins/i18n';

export default defineComponent({
  setup() {
    const { t } = useLabel();

    const hideTaxReductionInfo = computed(() => store.state.hideTaxReductionInfo);

    const prerequisites = computed(() => {
      const globalI18n = i18n.vueI18n.global;
      const locale = globalI18n.locale.value;
      const messages = globalI18n.getLocaleMessage(locale);

      const items = messages.taxReductionInfo.prerequisites;
      return items as Array<string>;
    });

    return {
      t,
      hideTaxReductionInfo,
      prerequisites,
    };
  },
});
</script>

<style scoped>
.info-cursor {
  cursor: help;
}
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
}
ul.pt-3 {
  list-style: disc;
}
ul.pt-3 li {
  margin-bottom: 12px;
}
</style>
